import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class ConsumerPrepayAmountManagerHandler {
 	url: any;
 	token: any;
  	businessId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getPrepayAmounts(params){	
	  	this.url = this.globals.dataUrl + 'consumerPrepayAmount' + 
	                                      '/business/' + params.businessId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

}



// WEBPACK FOOTER //
// ./src/providers/consumer-prepay-amount-handler.ts